import { PasswordIndications, useToast } from "@hellocarbo/lasagne";
import { useState } from "react";
import { useTranslation } from "react-i18next";

import { cn } from "@/utils/classes";

function PasswordConstraints() {
  const { t } = useTranslation("passwordConstraints");
  const [password, setPassword] = useState("");
  const path = window.location.pathname;
  let isEdit = false;
  if (path.includes("users/edit")) {
    isEdit = true;
  }

  const passwordInput = (document.getElementById("password") ||
    document.getElementById("user_password")) as HTMLInputElement;
  const { toast } = useToast();

  if (!passwordInput) {
    return null;
  }

  passwordInput?.addEventListener("input", () => {
    setPassword(passwordInput.value);
  });

  const showInvalidToast = (e: Event) => {
    e.preventDefault();
    const button = e.currentTarget as HTMLButtonElement;
    button?.blur();

    toast({
      title: t("invalid"),
      toastType: "simple",
      intent: "negative",
    });
  };

  const submitButton = document.querySelector(
    '[type="submit"], [data-persistent-id="submitButton"]'
  ) as HTMLButtonElement;

  if (!submitButton) {
    return null;
  }

  submitButton.dataset.persistentId = "submitButton"; // needed because we remove type="submit" on invalid password and no other selector is robust enough for all pages

  // Enables or disabled the submit button depending on the validity of the password
  const handleValidity = (valid: boolean) => {
    if (submitButton) {
      if (valid) {
        submitButton.type = "submit";
        submitButton.onclick = null;
      } else {
        submitButton.type = "button";
        submitButton.onclick = showInvalidToast;
      }
    }
  };

  return (
    <div
      className={cn(
        "max-h-[300px] overflow-hidden transition-all duration-300 ease-in-out",
        !isEdit &&
          "mt-xs border-grayscale-xx-light p-sm rounded-md border bg-white shadow-md",
        password === "" && "m-0! max-h-0 border-0! p-0!"
      )}
    >
      <PasswordIndications
        text={t("mustContain")}
        password={password}
        setValid={handleValidity}
        constraintText={{
          minLength: t("constraints.minLength"),
          hasUppercase: t("constraints.hasUppercase"),
          hasLowercase: t("constraints.hasLowercase"),
          hasDigit: t("constraints.hasDigit"),
          hasSymbol: t("constraints.hasSymbol"),
        }}
      />
    </div>
  );
}

export default PasswordConstraints;
